import { render, staticRenderFns } from "./BuyPart.vue?vue&type=template&id=8e702fd8&scoped=true&lang=pug&"
import script from "./BuyPart.vue?vue&type=script&lang=js&"
export * from "./BuyPart.vue?vue&type=script&lang=js&"
import style0 from "./BuyPart.vue?vue&type=style&index=0&id=8e702fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e702fd8",
  null
  
)

export default component.exports